import Vue from 'vue';

export function countrySelected(state) {
  return state.countrySelected;
}
export function countryData(state, getters, rootState) {
  let data = state.data;
  let country = {};
  let result = {};

  // Get the specified country
  Object.keys(data).forEach(function (key) {
    if (state.countrySelected == key) {
      country = data[key];
    }
  });

  return country;
}

export function countryAge(state, getters, rootState) {
  let data = getters.countryData.age;
  let count = 0;
  let result = {};
  let categories = {};
  let labels = [];
  let values = {};

  // Category Formating
  categories = ['Male', 'Female'];
  values.right = [];
  values.left = [];

  // Format the data for echart output
  Object.keys(data).forEach(function (key) {
    // Labels
    labels[count] = data[key].group;

    if (data[key].male) {
      // Data
      values.right[count] = '-1' * data[key].male;
      values.left[count] = data[key].female;
    }

    count++;
  });

  result = {
    categories: categories,
    labels: labels,
    values: values
  };

  return result;
}
export function countryIncome2(state, getters, rootState) {
  let data = getters.countryData.ethnicity;
  let count = 0;
  let result = {};
  let labels = [];
  let values = [];

  // Category Formating

  // Format the data for echart output
  Object.keys(data).forEach(function (key) {
    // Labels
    labels[count] = key;

    // Data
    values[count] = data[key];

    count++;
  });

  result = {
    labels: labels,
    values: values
  };

  return result;
}

export function countryEthnicity(state, getters, rootState) {
  let data = getters.countryData.ethnicity;
  let count = 0;
  let result = [];
  let row = {};

  // Format the data for echart output
  Object.keys(data).forEach(function (key) {
    row = {};

    // Labels
    row.name = key;
    row.value = data[key];

    // Data
    result[count] = row;

    count++;
  });

  return result;
}
export function countryLanguages(state, getters, rootState) {
  let data = getters.countryData.languages;
  let count = 0;
  let result = [];
  let row = {};

  // Format the data for echart output
  Object.keys(data).forEach(function (key) {
    row = {};

    // Labels
    row.name = key;
    row.value = data[key];

    // Data
    result[count] = row;

    count++;
  });

  return result;
}

export function countryLanguages2(state, getters, rootState) {
  let data = getters.countryData.languages;
  let count = 0;
  let result = {};
  let labels = [];
  let values = [];

  // Category Formating

  // Format the data for echart output
  Object.keys(data).forEach(function (key) {
    // Labels
    labels[count] = key;

    // Data
    values[count] = data[key];

    count++;
  });

  result = {
    labels: labels,
    values: values
  };

  return result;
}
export function countryIndex(state, getters, rootState) {
  let key = 1;
  let result = {};
  let labels = [];
  let values = [];

  // Category Formating
  for (key = 0; key <= 101; key++) {
    if (key == 101 - 11) {
      // Labels
      labels[key] = 'Austria';
    } else {
      // Labels
      labels[key] = key;
    }
    labels[key] = key;

    // Data
    values[key] = key * key;
    //values[key] =  --key * key * key + 1
  }

  result = {
    labels: labels,
    values: values
  };

  return result;
}
export function countryEducation(state, getters, rootState) {
  return [
    { value: 33.92, name: 'Baechelors Degree' },
    { value: 33.7, name: 'Vocational Education' },
    { value: 18.82, name: 'Master Degree or above' },
    { value: 8.53, name: 'High School' }
  ];
}

export function countryMarital(state, getters, rootState) {
  return [
    { value: 38.5, name: 'Couples without children' },
    { value: 33.2, name: 'Singles without children' },
    { value: 21.8, name: 'Families with children' },
    { value: 0.6, name: 'Singles with children' }
  ];
}
/*      {value: 5.03, name: 'Do not know'}
      {value: 6, name: 'Other Type'},*/

export function countryIncome(state, getters, rootState) {
  return {
    labels: [
      'Below 20k €',
      '20k € - 40k €',
      '40k € - 65k €',
      '65,0000€ - 95,000€',
      '95,0000€ - 150,000€',
      '150,0000€ or more'
    ],
    values: [9.73, 21.52, 21.83, 17.16, 11.19, 1.74]
  };
}
export function countryBudget(state, getters, rootState) {
  return {
    labels: [
      'Below 1,000€',
      '1,0000€ - 3,000€',
      '3,0000€ - 5,000€',
      '5,0000€ - 10,000€',
      '10,0000€ - 20,000€',
      '20,0000€ - 30,000€',
      '30,0000€ - 40,000€',
      '40,0000€ - 50,000€',
      '50,0000€ or more'
    ],
    values: [18.83, 33.73, 19.79, 16.92, 6.08, 2.62, 1.19, 0.48, 0.24]
  };
}

export function countryPreviousBudget(state, getters, rootState) {
  return [
    { value: 28.21, name: 'Smaller' },
    { value: 47.64, name: 'Same' },
    { value: 7.49, name: 'Bigger' }
    /*{value: 0.6, name: 'Singles with children'}
    "labels": ["Smaller", "Same", "Bigger"],
    "values": [28.21, 47.64, 7.49]*/
  ];
}
